import MuiTypography, {
  TypographyProps as MuiTypographyProps
} from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import {
  SystemProps,
  unstable_extendSxProp as extendSxProp
} from '@mui/system';
import React from 'react';

/**
 * Keep MUI v7-style system props working on Typography. Material UI v9 removed
 * them from the public API; map them into `sx` for backwards compatibility.
 * Except for `color`: keep it as Typography's semantic prop (e.g. "primary").
 */
export type TypographyProps = Omit<SystemProps<Theme>, 'color'> &
  MuiTypographyProps;

/** Extension of [Material-UI Typography](https://mui.com/material-ui/react-typography/)
 *
 */
export function Typography({ color, ...props }: TypographyProps) {
  return <MuiTypography color={color} {...extendSxProp(props)} />;
}
